import React from "react";
import "./contact.style.css";
import Jumbotron from "react-bootstrap/Jumbotron";
import Tilt from "react-tilt";
export default function contact() {
  return (
    <div id="contact">
      <h1 className="pt-3 text-center font-details-b pb-3 title">CONTACT US</h1>
      <Jumbotron className="jumbo-style">
        <Tilt options={{ max: 25 }}>
          <section className="contact" id="contact">
            <div className="max-width">
              <div className="contact-content">
                <div className="column left">
                  <div className="text">Feel Free To Ask Us</div>
                  <ul id="q" className="sci">
                    <li>
                      <a href="#">
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-github"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-google"></i>
                      </a>
                    </li>
                  </ul>

                  <div className="icons">
                    <div className="row">
                      <i className="fas fa-user"></i>
                      <div className="info">
                        <div className="head">Name</div>
                        <div className="sub-title">Yash Verma</div>
                      </div>
                    </div>
                    <div className="row">
                      <i className="fas fa-map-marker-alt"></i>
                      <div className="info">
                        <div className="head">Address</div>
                        <div className="sub-title">Chandigarh,India</div>
                      </div>
                    </div>
                    <div className="row">
                      <i className="fas fa-envelope"></i>
                      <div className="info">
                        <div className="head">Email</div>
                        <div className="sub-title">yash@gmail.com</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column right">
                  <div className="text">Message me</div>
                  <form action="#">
                    <div className="fields">
                      <div className="field name">
                        <input type="text" placeholder="Name" required />
                      </div>
                      <div className="field email">
                        <input type="email" placeholder="Email" required />
                      </div>
                    </div>
                    <div className="field">
                      <input type="text" placeholder="Subject" required />
                    </div>
                    <div className="field textarea">
                      <changeit
                        cols="30"
                        rows="10"
                        placeholder="Message.."
                        required
                      ></changeit>
                    </div>
                    <div className="button">
                      <button type="submit">Send message</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </Tilt>
      </Jumbotron>
    </div>
  );
}
